function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import DropdownIcon from '@bfly/icons/Dropdown';
import styled from 'astroturf'
import React from 'react';
const BadgeButton = /*#__PURE__*/styled('button', null, {
  displayName: "BadgeButton",
  styles: require("./Carousel-BadgeButton.module.scss"),
  attrs: null,
  vars: []
});
const styles = require('./Carousel-styles.module.scss');

function renderControl(className, onClick, disabled, enableFocus) {
  const buttonProps = enableFocus ? {
    disabled
  } : {
    as: 'span',
    className: disabled ? 'disabled' : ''
  };
  return React.createElement("div", {
    className: className
  }, React.createElement(BadgeButton, _extends({}, buttonProps, {
    onClick: !disabled ? onClick : undefined
  }), React.createElement(DropdownIcon, null)));
}

function Carousel({
  isFirst,
  isLast,
  onPrev,
  onNext,
  children,
  enableControlFocus = false
}) {
  const onlyImage = isFirst && isLast;
  return React.createElement("div", {
    className: styles.container
  }, children, !onlyImage && React.createElement(React.Fragment, null, renderControl(styles.left, onPrev, isFirst, enableControlFocus), renderControl(styles.right, onNext, isLast, enableControlFocus)));
}

export default Carousel;